@if (dataSource && currentTab && extractedActions) {
  <div class="row-actions-wrapper">
    @if (_data.locked) {
      <div class="row-actions-content">
        <div class="left-gradiend">dsa</div>
        @if (_data.locked.email && _data.locked.email.length > 0 && _data.locked.email === getCurrentUserEmail()) {
          @for (command of iconButtons; track command) {
            <button
              (click)="invokeAction(command.command)"
              type="button"
              mat-icon-button
              [matTooltip]="command.buttonLabel"
              class="quick-access-button">
              <i class="fas fa-{{ command.icon }}"></i>
            </button>
          }
          <button type="button" mat-icon-button matTooltip="Unlock" (click)="unlock()" class="lock-button">
            <i class="fas fa-lock" style="color: #c90000"></i>
            <i class="fas fa-unlock" style="color: #c90000"></i>
          </button>
          @if (anyActions) {
            <button type="button" mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
              @if (!actionInProgress) {
                <i class="fas fa-ellipsis-v"></i>
              }
              @if (actionInProgress) {
                <mat-spinner [diameter]="24"></mat-spinner>
              }
            </button>
          }
        }
        @if (_data.locked.email && _data.locked.email.length > 0 && _data.locked.email !== getCurrentUserEmail()) {
          <button type="button" mat-icon-button matTooltip="Unlock" (click)="unlock()" class="lock-button">
            <i class="fas fa-lock" style="color: #c90000"></i>
            <i class="fas fa-unlock" style="color: #c90000"></i>
          </button>
          <button type="button" mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
            <img
              src="{{ _data.locked.image }}"
              matTooltip="Locked by {{ _data.locked.email }}"
              style="width: 24px; height: 24px; border-radius: 100px" />
            @if (actionInProgress) {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </button>
        }
        @if (_data.locked.email === null || _data.locked.email.length === 0) {
          <button type="button" mat-icon-button matTooltip="Lock" (click)="lock()" class="lock-button">
            <i class="fas fa-unlock" style="color: #1f9d3b"></i>
            <i class="fas fa-lock" style="color: #229d3b"></i>
          </button>
          @if (anyActions) {
            <button
              [disabled]="true"
              type="button"
              mat-icon-button
              matTooltip="Lock first to access menu"
              [matMenuTriggerFor]="menu"
              class="more-button">
              <i class="fas fa-ellipsis-v"></i>
            </button>
          }
        }
      </div>
    }
    @if (detailsNavigation()) {
      <div>
        <a [routerLink]="getDetailsLink()">
          <button type="button" mat-icon-button>
            <mat-icon style="font-size: 18px">search</mat-icon>
          </button>
        </a>
      </div>
    }
    @if (!_data.locked && anyActions) {
      <div style="width: 40px; text-align: right">
        @if (anyActions) {
          <button type="button" data-id="table_menu" mat-icon-button [matMenuTriggerFor]="menu">
            @if (!actionInProgress) {
              <i class="fas fa-ellipsis-v"></i>
            }
            @if (actionInProgress) {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </button>
        }
      </div>
    }
    <mat-menu #menu="matMenu">
      @for (action of extractedActions.simple; track action) {
        <button type="button" mat-menu-item (click)="invokeAction(action.command)">
          <span>{{ action.label }}</span>
        </button>
      }
      @for (action of extractedActions.rest; track action) {
        <app-action
          [data]="_data"
          [actionConfig]="action"
          [menuItemMode]="true"
          (onActionStart)="actionStarted()"
          (onResponse)="actionFinished($event)"></app-action>
      }
    </mat-menu>
  </div>
}
